/* eslint-disable no-alert, no-console */
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "utils/api-client-wrapper";
import type { PutV1UsersAddressesIdMutationRequest, PutV1UsersAddressesIdMutationResponse, PutV1UsersAddressesIdPathParams, PutV1UsersAddressesId422 } from "../../../types/PutV1UsersAddressesId.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "utils/api-client-wrapper";

function getPutV1UsersAddressesIdUrlClient({ id }: { id: PutV1UsersAddressesIdPathParams["id"] }) {
  const res = { method: 'PUT', url: `/v1/users/addresses/${id}` as const }
  return res
}

/**
 * @summary Update address
 * {@link /v1/users/addresses/:id}
 */
export async function putV1UsersAddressesIdClient({ id }: { id: PutV1UsersAddressesIdPathParams["id"] }, data: PutV1UsersAddressesIdMutationRequest, config: Partial<RequestConfig<PutV1UsersAddressesIdMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<PutV1UsersAddressesIdMutationResponse, ResponseErrorConfig<PutV1UsersAddressesId422>, PutV1UsersAddressesIdMutationRequest>({ method : "PUT", url : getPutV1UsersAddressesIdUrlClient({ id }).url.toString(), data : requestData, ... requestConfig })
  return res
}